import { useState } from 'react';
import "./index.css";
import LoanCards from '../LoanCards';
import BasicLoanForm from '../LoanCards/LoanForms/BasicLoanForm/BasicLoanForm.js';
import Logo from "../../assets/images/svg/Logo.svg";
import ChatBot from '../ChatBot/ChatBot';
import { useCurrentUser } from '../../hooks/useCurrentUser';

const Dashboard = () =>{
  const decode = useCurrentUser();
    // console.log('decode',decode)



    const [loanTypeForm, setLoanTypeForm] = useState('')
    const handleLoanTypeForm = (loanType) => {
      setLoanTypeForm(loanType)
    }

    // React.useEffect(() => {
     
    //   if(decode?.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e")
    //   {
    
    //     navigate('/qec')
    //     window.location.reload()
    //   }
    
    // }, [decode])


    return(
    <>
    <div style={{width:"100%" ,height:'100%',backgroundColor:"#FFF"}}>
          <div className="fade-In">
              <div className="dashboard-welcome">
                <p className="dashboard-greeting">
                  Welcome back,&nbsp;
                  <span className="dashboard-name">{decode.display_name}</span>
                </p>
                {!(decode?.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e" && decode.role === "institute_user") && (
                  <p className="dashboard-subtitle">
                    {loanTypeForm === ''
                      ? 'Select a loan type below to begin the applicant onboarding journey.'
                      : <>You are onboarding for&nbsp;<span className="dashboard-loan-type">{loanTypeForm}</span></>
                    }
                  </p>
                )}
              </div>
              {(decode?.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e" && decode.role ==="institute_user")?<img src={Logo}/>:
              <>
               {loanTypeForm === '' && (
                <>
                  <LoanCards handleLoanTypeForm={handleLoanTypeForm} clientId={decode.clientId}/>
                </>
               )}
            {(loanTypeForm !== "" && loanTypeForm !== 'Term Loan') && <BasicLoanForm loanType={loanTypeForm}/>}
              </>}
          </div>
    </div>
    {(decode?.role === 'crm' || decode.role === "crsa" || decode.role == "admin")?<ChatBot />: ''}
    </>
    )
}

export default Dashboard